'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialiseDao = initialiseDao;
exports.getDaoBaseUrl = getDaoBaseUrl;
exports.getDaoDeviceType = getDaoDeviceType;
exports.getDaoDeviceId = getDaoDeviceId;
exports.getDaoAnalytics = getDaoAnalytics;
var _baseUrl, _deviceType, _deviceId, _analytics;

function initialiseDao(baseUrl, deviceType, deviceId, analytics) {
	_baseUrl = baseUrl;
	_deviceType = deviceType;
	_deviceId = deviceId;
	_analytics = analytics;
}

function getDaoBaseUrl() {
	return _baseUrl || '';
}

function getDaoDeviceType() {
	return _deviceType || '';
}

function getDaoDeviceId() {
	return _deviceId || '';
}

function getDaoAnalytics(analytics) {
	return _analytics || {
		setUserId: function setUserId() {},
		sendEvent: function sendEvent() {},
		sendTiming: function sendTiming() {},
		sendException: function sendException() {}
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/configuration/daoConfiguration.js
 ** module id = 110
 ** module chunks = 0
 **/